import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "dialogContainer" }, null, -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Header = _resolveComponent("Header")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_GenericDialog = _resolveComponent("GenericDialog")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_Toast, { position: "bottom-right" }),
      _hoisted_1,
      _createElementVNode("div", null, [
        (!_ctx.$route.meta.hideHeader)
          ? (_openBlock(), _createElementBlock("header", _hoisted_2, [
              _createVNode(_component_Header),
              (_ctx.showBreadcrumb)
                ? (_openBlock(), _createBlock(_component_Breadcrumb, { key: 0 }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_view, { onGetAuthCode: _ctx.getAuthCode }, null, 8, ["onGetAuthCode"])
        ]),
        (!_ctx.$route.meta.hideHeader)
          ? (_openBlock(), _createBlock(_component_TheFooter, { key: 1 }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_GenericDialog),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 0,
          fullScreen: true
        }))
      : _createCommentVNode("", true)
  ], 64))
}